import { useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { useEffect, useRef, useState } from 'react';
import GetChannelPasscodeListProjectUsage from '../audiences/channel-passcode-list-project-usage';
import useOnFinishSave from '@/utils/use-on-finish-save';

const useFetchProjectNamesForList = () => {
  const channel = useAppSelector(getActiveChannel);
  const [passcodeListProjectUsage, setPasscodeListProjectUsage] = useState<Record<number, string[]> | undefined>(
    undefined
  );
  const [counter, setCounter] = useState(1);

  const abortControllerRef = useRef<AbortController | null>(null);
  const fetching = useRef(false);

  useOnFinishSave({
    saveId: 'passcode-list-added',
    onSuccess: () => {
      fetching.current = false;
      setCounter((prev) => prev + 1);
    },
  });

  useEffect(() => {
    if (!channel) return;

    abortControllerRef.current?.abort();
    abortControllerRef.current = new AbortController();
    fetching.current = true;

    const fetchPasscodeListProjectUsage = async () => {
      const signal = abortControllerRef.current!.signal;
      try {
        const usage = await GetChannelPasscodeListProjectUsage({
          channel,
          signal,
        });
        setPasscodeListProjectUsage(usage);
      } catch (error) {
        if ((error as DOMException).name !== 'AbortError') {
          console.error('Error fetching audience list usage', error);
        }
      } finally {
        fetching.current = false;
      }
    };

    fetchPasscodeListProjectUsage();
  }, [channel, counter]);

  return passcodeListProjectUsage;
};

export default useFetchProjectNamesForList;
